import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { SearchViewModel } from '@api/v3';
import { callService } from '@api/remote-call';

export const useSelectedLocationSearchPackage = (
  enabled: boolean,
  queryDependency: any[] = []
) => {
  const params = useParams();

  const [selectedLocation, setSelectedLocation] = useState<SearchViewModel>();
  // ================================================
  // Fetch locations/hotels and fill the search by location
  // ================================================
  const fetchLocationsItems = async () => {
    return callService(
      { service: 'SearchesService', method: 'searchesPackage', version: 'v3' },
      {
        s: String(params?.slug).split('-').join(' ')?.toLocaleLowerCase(),
      }
    );
  };

  const { data: locations = [] } = useQuery(
    ['locationItems', ...queryDependency],
    fetchLocationsItems,
    { enabled }
  );

  useEffect(() => {
    if (!locations) return;

    const currentLocation = locations?.find(
      (item) => item.url === params?.slug
    );

    if (currentLocation && currentLocation.text) {
      setSelectedLocation(currentLocation);
    }
  }, [locations, params]);

  return { selectedLocation };
};
